import React from 'react'
import { Checkbox, Grid } from '@material-ui/core'

const CheckItem = ({ label, isSelected, onCheckboxChange }) => (
  <Grid item xs={12} md={4}>
    <label>
      <Checkbox
        type='checkbox'
        name={label}
        checked={isSelected}
        onChange={onCheckboxChange}
      />
      {label}
    </label>
  </Grid>
)

export default CheckItem
